import {hideAllMenus} from "../../logic/click-menu/helpers";


export function loadDbMenu() {
    if (!hasDbMenu())
        return;

    GlobalEnt.dbMenu = new DbMenu();
    GlobalEnt.dbMenu.init();
}

export function hasDbMenu() {
    return document.querySelector('.dbMenu');
}

export class DbMenu {
    constructor() {
        // code added by RAP for touchscreen support @videx.com
        this.clickedOn = null;
        this.clickedChild = null;
    }

    init() {
        const self = this;

        const uls = document.getElementsByTagName('ul');
        for (let i = 0; i < uls.length; i++) {
            if (uls[i].className.search(/\bdbMenu\b/) === -1)
                continue;

            const menu = uls[i];
            const subMenus = menu.getElementsByTagName('ul');

            for (let j = 0; j < subMenus.length; j++) {
                const parentLI = subMenus[j].parentNode;
                parentLI.hasSubMenu = true;

                const links = parentLI.getElementsByTagName('a');
                if (!links || links.length === 0) {
                    console.error('Missing row items for a click category...');
                    continue;
                }

                if (menu.className.search(/\bonClick\b/) !== -1){
                    parentLI.addEventListener('click', () => {
                        self.click();
                    });

                    // code added by RAP for touchscreen support @videx.com
                    // back up the hyperlink for use on subsequent clicks (touch screens)
                    if ("ontouchstart" in window) {
                        links[0].name = parentLI.getElementsByTagName('a')[0].href;
                    }

                    links[0].href = "#";
                } else {
                    // code added by RAP for touchscreen support @videx.com
                    if ("ontouchstart" in window) {
                        links[0].name = links[0].href;
                        links[0].href = "#";
                    } else {
                        parentLI.addEventListener('mouseout', () => {
                            self.getMoutFor(parentLI);
                        });
                        parentLI.addEventListener('mouseover', () => {
                            self.getMoverFor(parentLI);
                        })
                    }

                    parentLI.addEventListener('click', function() {
                        self.click();
                    })
                }

                links[0].className += " subMenu";
            }

            // code added by RAP for touchscreen support @videx.com
            if ("ontouchstart" in window) {
                const subItems = menu.getElementsByTagName('a');
                for (let x = 0; x < subItems.length; x++) {
                    if ((subItems[x].href.search(/\b#\b/) === -1) && (subItems[x].name.length === 0)) {
                        subItems[x].addEventListener('click', function() {
                            self.click();
                        });

                        subItems[x].name = subItems[x].href;
                        subItems[x].href = "#";
                    }
                }
            }
        }

        const dropDown = document.getElementById("dropDown");
        if (dropDown) {
            /* fix for Firefox on Mac */
            if ((navigator.userAgent.indexOf("Firefox") !== -1) && (navigator.platform.indexOf("Mac") !== -1)) {
                const elms = dropDown.getElementsByTagName("ul");
                if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
                    const ffversion = new Number(RegExp.$1) // capture x.x portion and store as a number
                    if (ffversion < 3) {
                        for (let k = 0; k < elms.length; k++) {
                            elms[k].style.marginTop="3px";
                        }
                    }
                }
            }
        }
    };

    getMoverFor(node) {
        this.mOver(node);
    };

    getMoutFor(node) {
        this.mTimeout(node);
    };

    mOver(targetElement) {
        clearTimeout(targetElement.timeout);
        for(var i = 0; i < targetElement.childNodes.length; i++){
            var node = targetElement.childNodes[i];
            if (node.nodeName.toLowerCase() === "ul"){
                targetElement.getElementsByTagName("a")[0].classList.add("click");
                targetElement.classList.add("click");
                node.classList.add("click");
            }
        }
    };

    mTimeout(targetElement) {
        var target = targetElement;
        target.timeout = setTimeout(() => {
            this.mOut(target);
        }, 100);
    };

    mOut(target) {
        for(var i = 0; i < target.childNodes.length; i++){
            var node = target.childNodes[i];
            if (node.nodeName.toLowerCase() === "ul"){
                target.getElementsByTagName("a")[0].classList.remove("click");
                node.classList.remove("click");
                target.classList.remove("click");
            }
        }
    };

    click(e) {
        if (window.event)
            window.event.cancelBubble = true;
        if (e && e.stopPropagation)
            e.stopPropagation();

        let target = (window.event)? window.event.srcElement : (e)? e.target : null;
        if(!target || !(target = this.getTarget(target, 'li')))
            return;

        const refElm = target.getElementsByTagName('a')[0];
        if (target.getElementsByTagName('a')[0].className.search(/\bclick\b/) === -1) {
            // code added by RAP for touchscreen support @videx.com
            if ("ontouchstart" in window) {
                // if this click occurred on a child, trigger the click
                // or if the click was a repeat on the same parent
                if ((target.getElementsByTagName('ul').length === 0)
                    || ((this.clickedChild != null)&&(this.clickedChild===target))) {
                    refElm.href=refElm.name;
                    return true;
                } else {
                    if ((this.clickedChild != null)
                        && (!this.isParent(this.clickedChild, target))) {
                        this.mOut(this.clickedChild);
                    }
                    this.clickedChild=target;
                }

                // otherwise hide any previous menu and cache the clicked element
                if ((this.clickedOn != null)
                    &&(!this.isParent(this.clickedOn, target))) {
                    this.hidePrevious();
                    this.clickedOn=target;
                } else if (this.clickedOn == null) {
                    this.clickedOn=target;
                }
            }

            // code added by RAP to hide Videx click menus on touchscreens
            // hide any visible click menu
            if ("ontouchstart" in window && this.isInDBMenu(target))
                hideAllMenus();

            this.mOver(target);

            // code added by RAP for touchscreen support @videx.com
            if ("ontouchstart" in window && e.preventDefault)
                e.preventDefault();
        } else {
            // code added by RAP for touchscreen support @videx.com
            if ("ontouchstart" in window) {
                // reinstate the hyperlink for use (touch screens)
                refElm.href=refElm.name;
                return true;
            }
            this.mOut(target);
        }

        // modification added by RAP for touchscreen support @videx.com
        return !("ontouchstart" in window);
    };

    // functions added by RAP for touchscreen support @videx.com
    hidePrevious() {
        if (this.clickedOn) {
            const subs = this.clickedOn.getElementsByTagName('ul');
            if (subs.length > 0) {
                for(let i = 0; i < subs.length; i++) {
                    this.mOut(subs[i]);
                }
            }

            this.mOut(this.clickedOn);
            this.clickedOn = null;
        }
    };

    isParent(p1, c1) {
        let p2 = c1;
        while (p1 && p2 && p2 !== p1 && p2 !== document) {
            p2 = p2.parentNode;
        }
        return p2 === p1;
    };

    isInDBMenu(test) {
        let findDropDown = null;
        let clickPattern = /dropDown/i;

        if (test) {
            // search up the parent nodes for the first UL
            while (test.parentNode && test.tagName !== "UL") {
                test = test.parentNode;
            }

            // if it is a dropDown UL, then we are in the Videx DBMenu (main menu)
            if (clickPattern.test(test.id))
                findDropDown = test;
        }

        return (findDropDown != null);
    };

    getTarget(target, elm) {
        if(target.nodeName.toLowerCase() !== elm && target.nodeName.toLowerCase() !== 'body'){
            return this.getTarget(target.parentNode, elm);
        }else if(target.nodeName.toLowerCase() === 'body'){
            return null;
        }else{
            return target;
        }
    };
}